import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Storage } from '@ionic/storage';


@Injectable()
export class OrderProvider {
  private listSizeSubject: Subject<number>;
  private _listSize: Observable<number>;
  private orders = [];

  constructor(private storage: Storage) {
    this.listSizeSubject = new Subject();
    this._listSize = this.listSizeSubject.asObservable();
  }

  get listSize(){
    return this._listSize;
  }

  public async updateBadge(){
    await this.storage.get('RetinaOrderBatch').then((batch) => {
      if(batch) {
        let count = 0;
        console.log('Order Badge Count Service: ', batch);
        batch.forEach((item, idx) => {
          console.log('Batch: ', item)
          item.rx.forEach((rx) => {
            console.log('RX: ', rx)
            count += 1
          })
          if (batch.length === (idx + 1))  {
            this.listSizeSubject.next(count);
          }
        });

       
      }
      else {
        this.listSizeSubject.next(null);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/order/order.ts